const carpayPaymentFinishedRoute = '/carpay/orders/:order_id/payment-finished'

export default carpayPaymentFinishedRoute
